// ------------------------------------
// Constants
// ------------------------------------
// prettier-ignore
export const NETWORK_INSTANCES_PUT_REQUEST = 'NETWORK_INSTANCES_PUT_REQUEST';
// prettier-ignore
export const NETWORK_INSTANCES_PUT_REQUEST_SUCCESS = 'NETWORK_INSTANCES_PUT_REQUEST_SUCCESS';
// prettier-ignore
export const NETWORK_INSTANCES_PUT_REQUEST_FAILURE = 'NETWORK_INSTANCES_PUT_REQUEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORK_INSTANCES_PUT_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(res) {
  return {
    type: NETWORK_INSTANCES_PUT_REQUEST_SUCCESS,
    data: res,
  };
}

export function requestFailure(error) {
  return {
    type: NETWORK_INSTANCES_PUT_REQUEST_FAILURE,
    error,
  };
}
